export default __webpack_public_path__ + "740226fb8a5db4549f524db6d29143f3.png";